import {
	styled,
	Text,
	TextAlignment,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { COLOR_TOKEN } from 'src/components/color-token';
import { TRANSITION_TIME } from 'src/globals';

const Mark = styled.span`
	display: inline-block;
	position: relative;
	border: 1px solid ${COLOR_TOKEN.main.content.primary};
	width: 24px;
	height: 24px;
	left: 0;
	border-radius: 50%;
	margin-right: 12px;
	vertical-align: middle;
	&::after {
		content: '';
		display: block;
		width: 0;
		height: 0;
		border-radius: 50%;
		background-color: ${COLOR_TOKEN.main.background.primary};
		opacity: 0;
		left: 50%;
		top: 50%;
		position: absolute;
		transition: all ${TRANSITION_TIME.FAST}ms;
	}
`;

const RadioButtonWrapper = styled.label`
	display: flex;
	justify-content: center;
	cursor: pointer;
	position: relative;
	color: ${COLOR_TOKEN.main.content.primary};
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;

	input {
		position: absolute;
		visibility: hidden;
		display: none;
		&:checked + ${Mark} {
			&::after {
				width: 12px;
				height: 12px;
				opacity: 1;
				left: 50%;
				top: 50%;
				transform: translate(-50%, -50%);
			}
		}
	}
`;

interface radioButtonProps {
	onClick?: any;
	inputName?: string;
	inputValue?: string;
	checked?: boolean;
}

export const CustomRadioButton = (props: radioButtonProps) => {
	return (
		<RadioButtonWrapper onClick={props.onClick}>
			<input
				type="radio"
				name={props.inputName}
				value={props.inputValue}
				checked={props.checked}
			/>
			<Mark />
			<Text
				appearance={TokenTextAppearance.copy200}
				staticSize
				color={TokenTextColor.inherit}
				textAlign={TextAlignment.left}
			>
				{props.inputValue}
			</Text>
		</RadioButtonWrapper>
	);
};
